var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-none text-[#FAFAFA] flex justify-between flex-grow mx-[108px]"},_vm._l((_vm.navItems),function(ref,i){
var label = ref.label;
var linkList = ref.linkList;
return _c('NavItem',{key:("nav-item-" + i),attrs:{"label":label,"linkList":linkList}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }